import { styled, Typography } from "@mui/material";
import { useState } from "react";
import { Scanner } from "@yudiel/react-qr-scanner";
import "./index.css";
import ClearIcon from "@mui/icons-material/Clear";
import httpClient from "../../configs/http-client";
import apiUrl from "../../constants/apiUrl";
import validator from "validator";
import { Loading } from "../../components";

export default function QRScanner(props: any) {
    const [isScanned, setIsScanned] = useState(false);
    const [isPolling, setIsPolling] = useState(false);
    const isAnonymousRedemption = props?.isAnonymousRedemption || false;
    const CustomClearItem = styled(ClearIcon)({
        zIndex: 100,
        position: "absolute",
        margin: "20px",
        top: "0",
        right: "0",
        fontSize: 40,
        color: "white",
        fontWeight: 600
    });

    const handleError = (err: any) => {
        console.error(err);
    };


    interface DialogInformation {
        is_success: boolean;
        msg_code?: string;
    }

    const updateDialogInformation = (info: DialogInformation) => {
        props.setDialogInformation(info);
    };

    const REDEEM_ATTEMPTS: number = parseInt(process.env.REACT_APP_REDEMPTION_POLL_COUNT || "15");

    const POLL_INTERVAL = 1000; // in milliseconds
    const REDEMPTION_SUCCEEDED = "REDEMPTION_SUCCEEDED";
    const DISCOUNT_APPLIED_SELECT_PRODUCT = "DISCOUNT_APPLIED_SELECT_PRODUCT";


    const redeemStatus = async (session_id: string, last_pull_request: boolean): Promise<boolean> => {
        try {
            const res = await httpClient.post(apiUrl.REDEEM_STATUS, {
                session_id,
                last_pull_request
            });
            if (res.status !== 200) {
                updateDialogInformation({ is_success: false, msg_code: res.data.msg_code });
                return false;
            }
            const successCodes = [REDEMPTION_SUCCEEDED, DISCOUNT_APPLIED_SELECT_PRODUCT];
            const isSuccess = successCodes.includes(res.data.msg_code);
            updateDialogInformation({ is_success: isSuccess, msg_code: res.data.msg_code });
            return isSuccess;
        } catch (error) {
            updateDialogInformation({ is_success: false });
            return false;
        }
    };

    const pollRedeemStatus = async (session_id: string): Promise<boolean> => {
        let counter = REDEEM_ATTEMPTS;
        let emptyCounter = 0;
        return new Promise((resolve) => {
            const interval = setInterval(async () => {
                const isSuccess = await redeemStatus(session_id, false);
                counter--;
                if (isSuccess || counter === 0) {
                    clearInterval(interval);
                    setIsPolling(false);
                    if (counter === 0) {
                        const finalResult = await redeemStatus(session_id, true);
                        resolve(finalResult);
                    }
                    else {
                        resolve(isSuccess);
                    }
                } else {
                    emptyCounter++;
                    if (emptyCounter >= REDEEM_ATTEMPTS) {
                        clearInterval(interval);
                        setIsPolling(false);
                        resolve(false);
                    }
                }
            }, POLL_INTERVAL);
        });
    };

    const handleScan = async (array: any) => {
        let result_text = array?.[0]?.rawValue ?? "";

        console.log(result_text);

        if (result_text) {
            let isV2Redeem = false;
            if (String(result_text).includes("v2_")) {
                isV2Redeem = true;
                result_text = String(result_text).replace("v2_", "");
            }
            let session_id: any = null;
            const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
            if (regexExp.test(result_text)) {
                session_id = result_text;
            }
            else if (validator.isURL(result_text)) {
                const url = new URL(result_text);
                const params = new URLSearchParams(url.search);
                session_id = params.get("session_id");
            }
            if (!isScanned) {
                if (!session_id) {
                    setIsScanned(true);
                    props.handleDialogOpen();
                    props.setDialogInformation(
                        {
                            body: (<div>
                                <Typography variant="caption" display="block" gutterBottom>
                                    Invalid session_id value {session_id}
                                </Typography>
                            </div>),
                        }
                    );
                } else {
                    setIsScanned(true);
                    let redeemUrl = isAnonymousRedemption ? apiUrl.ANONYMOUS_REDEEM_COUPON : isV2Redeem ? apiUrl.REDEEM_COUPON_V2 : apiUrl.REDEEM_COUPON;
                    httpClient.post(
                        redeemUrl,
                        {
                            coupon_code: props.coupon_code,
                            session_id: session_id
                        }).then(async (res) => {
                            const data = res.data;
                            props.handleDialogOpen();
                            if (!isV2Redeem) {
                                if (res.status == 200) updateDialogInformation({ is_success: true });
                                else updateDialogInformation({ is_success: false });
                            }
                            else if (isV2Redeem)
                                if (res.status == 200 && !data.failure) {
                                    setIsPolling(true);
                                    await pollRedeemStatus(session_id);
                                }
                                else {
                                    updateDialogInformation({ is_success: false, msg_code: data.msg_code });
                                }
                        })
                        .catch((error: any) => {
                            props.handleDialogOpen();
                            updateDialogInformation({ is_success: false, msg_code: error.response.data?.msg_code });
                        });
                }
            }
        }
    };

    return (
        <>
            {
                isPolling
                    ? <Loading customBackgroundColor="rgba(255,255,255,1)" />
                    : (
                        <div
                            style={{ position: "relative" }}
                            className="qr-code-scanner-customize-wrapper"
                        >
                            <CustomClearItem onClick={props.offCam} />
                            <Scanner
                                onError={handleError}
                                onScan={handleScan}
                                classNames={{ container: "qr-code-scanner-customize" }}
                            />
                        </div>
                    )
            }
        </>
    );
}
